const buildPayload = ({
    isDentalSpecialtyCompleted,
    dentalSpecialty,
    specialtySchoolAttended,
    yearSpecialtyCompleted,
    administeredAnestheticModalities,
    othersAdministerAnesthetic,
    isConsciousSedationAdministered,
    specialistTypeAdministeringAnesthesia,
    otherSpecialistType,
    isConsciousSedationInOfficeAdministered,
    ivImSedationAdministeredName,
    ivImSedationLicenseNumber,
    ivImSedationSpecialty,
    isGeneralAnesthesiaAdministered,
    generalAnesthesiaAdministeredName,
    generalAnesthesiaLicenseNumber,
    generalAnesthesiaSpecialty,
    consciousSedationAdministeredName,
    consciousSedationLicenseNumber,
    consciousSedationSpecialty,
    generalAnesthesiaDetailsAdministeredName,
    generalAnesthesiaDetailsLicenseNumber,
    generalAnesthesiaDetailsSpecialty
}) => {
    const buildRenewalQuestions = () => {
        const questions = [];

        const addQuestion = (questionText, answer, inputType, options = [],
            SelectedOptions = []) => {
            questions.push({
                question: questionText, answer, inputType, options, SelectedOptions
            });
        };

        let q1Answer = null;
        if (isDentalSpecialtyCompleted === true) {
            q1Answer = 'Yes';
        } else if (isDentalSpecialtyCompleted === false) {
            q1Answer = 'No';
        }
        const q1Options = [];
        if (isDentalSpecialtyCompleted === true) {
            q1Options.push(
                { optionName: '1a. Dental Specialty', optionValue: dentalSpecialty || null, inputType: 'input' },
                { optionName: '1b. Specialty School Attended', optionValue: specialtySchoolAttended || null, inputType: 'input' },
                { optionName: '1c. Year Specialty Training Completed', optionValue: yearSpecialtyCompleted || null, inputType: 'input' }
            );
        }
        addQuestion('Have you completed a dental specialty program?', q1Answer, 'radio', q1Options);


        const q2Options = [
            { optionName: 'None', optionValue: administeredAnestheticModalities.includes('None'), inputType: 'CheckboxField' },
            { optionName: 'Local anesthesia', optionValue: administeredAnestheticModalities.includes('Local anesthesia'), inputType: 'CheckboxField' },
            { optionName: 'N2O/O2 analgesia', optionValue: administeredAnestheticModalities.includes('N2O/O2 analgesia'), inputType: 'CheckboxField' },
            { optionName: 'Oral conscious sedation', optionValue: administeredAnestheticModalities.includes('Oral conscious sedation'), inputType: 'CheckboxField' },
            { optionName: 'Conscious sedation (including IV or IM) in office', optionValue: administeredAnestheticModalities.includes('Conscious sedation (including IV or IM) in office'), inputType: 'CheckboxField' },
            { optionName: 'General anesthesia in office', optionValue: administeredAnestheticModalities.includes('General anesthesia in office'), inputType: 'CheckboxField' }
        ];
        addQuestion('Do you administer or treat patients under any of the anesthetic modalities? Mark all that are administered by you:', '', 'title', q2Options, administeredAnestheticModalities);


        const q3Options = [
            { optionName: 'Conscious sedation (including IV or IM) in office', optionValue: othersAdministerAnesthetic.includes('Conscious sedation (including IV or IM) in office'), inputType: 'CheckboxField' },
            { optionName: 'General anesthesia in office', optionValue: othersAdministerAnesthetic.includes('General anesthesia in office'), inputType: 'CheckboxField' },
            { optionName: 'None', optionValue: othersAdministerAnesthetic.includes('None'), inputType: 'CheckboxField' }
        ];
        if (othersAdministerAnesthetic.includes('Conscious sedation (including IV or IM) in office') && !othersAdministerAnesthetic.includes('None')) {
            q3Options.push(
                { optionName: 'Please indicate who administers conscious sedation (including IV or IM) in office:', optionValue: '', inputType: 'title' },
                { optionName: '3a. Name (IV/IM)', optionValue: consciousSedationAdministeredName || null, inputType: 'input' },
                { optionName: '3b. License Number (IV/IM)', optionValue: consciousSedationLicenseNumber || null, inputType: 'input' },
                { optionName: '3c. Specialty (IV/IM)', optionValue: consciousSedationSpecialty || null, inputType: 'input' }
            );
        }

        if (othersAdministerAnesthetic.includes('General anesthesia in office') && !othersAdministerAnesthetic.includes('None')) {
            q3Options.push(
                { optionName: 'Please indicate who administers general anesthesia in office:', optionValue: '', inputType: 'title' },
                { optionName: '3d. Name (GA)', optionValue: generalAnesthesiaDetailsAdministeredName || null, inputType: 'input' },
                { optionName: '3e. License Number (GA)', optionValue: generalAnesthesiaDetailsLicenseNumber || null, inputType: 'input' },
                { optionName: '3f. Specialty (GA)', optionValue: generalAnesthesiaDetailsSpecialty || null, inputType: 'input' }
            );
        }
        addQuestion('Does anyone else administer any of the anesthetic modalities listed below?', '', 'title', q3Options, othersAdministerAnesthetic);

        if (othersAdministerAnesthetic.length >= 1 && !othersAdministerAnesthetic.includes('None')) {
            let q4Answer = null;
            if (isConsciousSedationAdministered === true) {
                q4Answer = 'Yes';
            } else if (isConsciousSedationAdministered === false) {
                q4Answer = 'No';
            }
            addQuestion('Is conscious sedation (including IV or IM) or general anesthesia in a hospital or surgicenter, administered by a dental anesthesiologist, M.D. anesthesiologist, CRNA or oral maxillofacial surgeon to your patients?', q4Answer, 'radio');
        }

        if (isConsciousSedationAdministered === true) {
            const q8Options = [
                { optionName: 'Dental Anesthesiologist', optionValue: specialistTypeAdministeringAnesthesia.includes('Dental Anesthesiologist'), inputType: 'CheckboxField' },
                { optionName: 'M.D. Anesthesiologist', optionValue: specialistTypeAdministeringAnesthesia.includes('M.D. Anesthesiologist'), inputType: 'CheckboxField' },
                { optionName: 'Oral and Maxillofacial Surgeon', optionValue: specialistTypeAdministeringAnesthesia.includes('Oral and Maxillofacial Surgeon'), inputType: 'CheckboxField' },
                { optionName: 'Other specialist', optionValue: specialistTypeAdministeringAnesthesia.includes('Other specialist'), inputType: 'CheckboxField' }
            ];

            if (specialistTypeAdministeringAnesthesia.includes('Other specialist')) {
                q8Options.push({ optionName: 'Please specify the other specialty type', optionValue: otherSpecialistType || null, inputType: 'input' });
            }
            addQuestion('Type of specialist administering anesthesia in a hospital to your patients', '', 'title', q8Options, specialistTypeAdministeringAnesthesia);
        }

        if (isConsciousSedationAdministered === false) {
            let q9Answer = null;
            const q9Options = [];
            if (isConsciousSedationInOfficeAdministered === true) {
                q9Answer = 'Yes';
                q9Options.push(
                    { optionName: 'Please indicate who administers IV IM Sedation in office:', optionValue: '', inputType: 'title' },
                    { optionName: '5a. Name', optionValue: ivImSedationAdministeredName || null, inputType: 'input' },
                    { optionName: '5b. License Number', optionValue: ivImSedationLicenseNumber || null, inputType: 'input' },
                    { optionName: '5c. Specialty', optionValue: ivImSedationSpecialty || null, inputType: 'input' }
                );
            } else if (isConsciousSedationInOfficeAdministered === false) {
                q9Answer = 'No';
            }
            addQuestion('Does someone administer IV or IM Sedation in office?', q9Answer, 'radio', q9Options);
        }

        if (isConsciousSedationInOfficeAdministered === false) {
            let q14Answer = null;
            const q14Options = [];
            if (isGeneralAnesthesiaAdministered === true) {
                q14Answer = 'Yes';
                q14Options.push(
                    { optionName: 'Please indicate who administers general anesthesia in office:', optionValue: '', inputType: 'title' },
                    { optionName: '6a. Name', optionValue: generalAnesthesiaAdministeredName || null, inputType: 'input' },
                    { optionName: '6b. License Number', optionValue: generalAnesthesiaLicenseNumber || null, inputType: 'input' },
                    { optionName: '6c. Specialty', optionValue: generalAnesthesiaSpecialty || null, inputType: 'input' }
                );
            } else if (isGeneralAnesthesiaAdministered === false) {
                q14Answer = 'No';
            }
            addQuestion('Does someone administer general anesthesia in office?', q14Answer, 'radio', q14Options);
        }

        return questions;
    };

    return buildRenewalQuestions();
};

export default buildPayload;
